
export enum BulkActionTypes {    
  PUT_BULK_REQUEST = "@@bulk/PUT_BULK_REQUEST",
  PUT_BULK_SUCCESS = "@@bulk/PUT_BULK_SUCCESS",
  PUT_BULK_ERROR = "@@bulk/PUT_BULK_ERROR",
  DELETE_BULK_REQUEST = "@@bulk/DELETE_BULK_REQUEST",
  DELETE_BULK_SUCCESS = "@@bulk/DELETE_BULK_SUCCESS",
  DELETE_BULK_ERROR = "@@bulk/DELETE_BULK_ERROR",
}

export interface BulkState {
    readonly loading: boolean;
    readonly dataLoading: boolean;
}
